var _class;
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import { autoJoin, chainCommands, createParagraphNear, lift, selectNodeForward, setBlockType, toggleMark } from 'prosemirror-commands';
import { AllSelection, NodeSelection, Selection, TextSelection } from 'prosemirror-state';
import { redo, undo } from 'prosemirror-history';
import { undoInputRule } from 'prosemirror-inputrules';
import { action } from '@ember/object';
import { Slice } from 'prosemirror-model';
import { liftListItem, wrapInList } from 'prosemirror-schema-list';
import { guidFor } from '@ember/object/internals';
import { processImageFile, updateImageNodeWithProcessingResult } from '../helpers/image';
import { updateNodeWithUploadResult } from '../helpers/file';
import { centerablesInSelection, dominantAlignment } from '../helpers/center';
import { toggleCodeBlock } from '../helpers/code-blocks';
import { changeNestedList } from '../helpers/lists';
import { determineVideoMetadata, updateVideoFileNodeWithDurationAndUploadResults } from '../helpers/video';
import { updateAudioFileNodeWithUploadResults } from '../helpers/audio';
import { ALIGNMENTS, BLOCK_TYPES } from '../blocks/constants';
import BlocksParser from '../blocks/parser';
import BlocksDocument from '../blocks/blocks-document';
import AttachmentList from './attachment-list';
import { insertPoint } from 'prosemirror-transform';
import { findParentNode, findTextNodes } from 'prosemirror-utils';
import { findSelectionAnchorNode } from '@intercom/composer-ember/lib/helpers/selection';
import dataURItoBlob from '@intercom/composer-ember/lib/helpers/data-uri-to-blob';
import { cleanUrl } from '../helpers/clean-url';
import BlocksSerializer from '../blocks/serializer';
import { changesetStateFrom } from '../commands/change-highlight';
import StylingCommands from './commands/styling-commands';
import { highlightContentPluginKey } from '../config/highlight-content';
import { selectionHasMark } from '../helpers/selection';
let Commands = (_class = class Commands {
  constructor(editorView, config, uploadManager, attachmentList, insertTicketCardBlock) {
    _defineProperty(this, "isDestroying", false);
    _defineProperty(this, "markerCounter", 0);
    _defineProperty(this, "styling", void 0);
    this.editorView = editorView;
    this.config = config;
    this.uploadManager = uploadManager;
    this.attachmentList = attachmentList;
    this.insertTicketCardBlock = insertTicketCardBlock;
    this.styling = new StylingCommands(this.editorView, this.config);
  }
  focus() {
    if (!this.isDestroying) {
      this.editorView.focus();
    }
  }
  collapseSelection() {
    this.dispatch(this.editorView.state.tr.setSelection(TextSelection.create(this.editorView.state.doc, this.editorView.state.selection.from)));
  }
  collapseSelectionToEnd() {
    this.dispatch(this.editorView.state.tr.setSelection(TextSelection.create(this.editorView.state.doc, this.editorView.state.selection.to)));
  }
  setSelectionToEnd() {
    this.dispatch(this.editorView.state.tr.setSelection(Selection.atEnd(this.editorView.state.doc)));
  }
  async transformSelection(transform) {
    // start transaction
    let tr = this.editorView.state.tr;

    // get current content
    let selectionContent = this.editorView.state.selection.content();
    let selectionBlocksContent = new BlocksSerializer(this.config, this.editorView.state.schema).serializeSlice(selectionContent).blocks;
    let transformedBlocks = await transform(selectionBlocksContent);

    // replace selection
    let slice = this.createSliceForContent(transformedBlocks);
    tr.replaceSelection(slice);
    this.dispatch(tr);
  }
  toggleMarkType(markTypeName, attrs) {
    let markType = this.schema.marks[markTypeName];
    toggleMark(markType, attrs)(this.editorView.state, this.dispatch);
  }
  addMarkType(markTypeName, attrs) {
    let markType = this.schema.marks[markTypeName];
    let newMark = markType.create(attrs);
    let transaction = this.editorView.state.tr.addMark(this.editorView.state.selection.from, this.editorView.state.selection.to, newMark);
    if (transaction) {
      this.dispatch(transaction);
    }
  }
  toggleNodeType(nodeTypeName, nodeAttrs, offTypeName) {
    if (nodeTypeName === 'codeBlock') {
      let tr = toggleCodeBlock(this.editorView.state, this.schema);
      if (tr) {
        this.dispatch(tr);
      }
    } else {
      let nodeType = this.schema.nodes[nodeTypeName];
      let offType = this.schema.nodes[offTypeName || 'paragraph'];
      let parent = this.editorView.state.selection.$from.parent;
      let attrs = {
        alignment: parent.attrs.alignment,
        fontFamily: parent.attrs.fontFamily,
        fontColor: parent.attrs.fontColor
      };
      if (nodeAttrs) {
        attrs = Object.assign({}, nodeAttrs, attrs);
      }
      if (!this.schema.nodes.nestedListItem) {
        lift(this.editorView.state, this.dispatch);
      }
      if (parent.type === nodeType) {
        setBlockType(offType, attrs)(this.editorView.state, this.dispatch);
      } else {
        setBlockType(nodeType, attrs)(this.editorView.state, this.dispatch);
      }
    }
  }
  findTextNodes(parentNodeType) {
    let parent = findParentNode(node => {
      return node.type.name === parentNodeType;
    })(this.currentNodeSelection);
    if (parent !== undefined) {
      return findTextNodes(parent.node);
    }
    return [];
  }
  toggleCenter() {
    let newAlignment = dominantAlignment(this.selectedCenterables) === ALIGNMENTS.left ? ALIGNMENTS.center : ALIGNMENTS.left;
    this.setTextAligment(newAlignment);
  }
  setTextAligment(newAlignment) {
    let centerables = this.selectedCenterables;
    let tr = this.editorView.state.tr;
    centerables.forEach(centerable => {
      let newAttrs = Object.assign({}, centerable.node.attrs, {
        alignment: newAlignment
      });
      tr.setNodeMarkup(centerable.pos, undefined, newAttrs);
    });
    this.dispatch(tr);
  }
  get selectedCenterables() {
    let centerables = [];
    if (this.currentNodeSelection?.node && (this.isSelectedNodeType(BLOCK_TYPES.BUTTON) || this.isSelectedNodeType(BLOCK_TYPES.IMAGE) || this.isSelectedNodeType(BLOCK_TYPES.SOCIAL))) {
      selectNodeForward(this.editorView.state, this.dispatch);
      let node = this.currentNodeSelection.node;
      let pos = this.editorView.state.selection.$anchor.pos;
      centerables.push({
        pos,
        node
      });
    } else {
      centerables = centerablesInSelection(this.editorView.state);
    }
    return centerables;
  }
  insertText(text) {
    this.insertTextAtRange(this.currentRange, text);
  }
  insertTextAtRange(range, text) {
    this.dispatch(this.editorView.state.tr.insertText(text, range.from, range.to));
  }
  insertBlock(block) {
    this.insertBlockAtRange(this.currentRange, block);
  }
  insertBlocks(blocks) {
    let slice = this.createSliceForContent(blocks);
    let tr = this.editorView.state.tr;
    let currentRange = this.currentRange;
    tr.replaceRange(currentRange.from, currentRange.to, slice);
    tr = tr.scrollIntoView();
    this.dispatch(tr);
    this.insertAttachments(blocks);
  }
  highlightAll() {
    let tr = this.editorView.state.tr;
    tr.setMeta(highlightContentPluginKey, {
      highlight: true
    });
    this.dispatch(tr);
  }
  clearHighlights() {
    let tr = this.editorView.state.tr;
    tr.setMeta(highlightContentPluginKey, {
      highlight: false
    });
    this.dispatch(tr);
  }
  insertBlockAtRange(range, block) {
    let node = this.createSlice([block]).content.firstChild;
    this.insertNodeAtRange(range, node);
  }
  replaceAllWithBlocks(blocks) {
    let tr = this.editorView.state.tr;
    let allSelection = new AllSelection(tr.doc);
    tr.setSelection(allSelection);
    let slice = this.createSlice(blocks);
    tr.replaceSelection(slice);
    this.dispatch(tr);
  }
  replaceAllWithBlock(block) {
    let tr = this.editorView.state.tr;
    let allSelection = new AllSelection(tr.doc);
    tr.setSelection(allSelection);
    let node = this.createSlice([block]).content.firstChild;
    if (node) {
      tr.replaceSelectionWith(node);
    }
    this.dispatch(tr);
  }
  selectAll() {
    let tr = this.editorView.state.tr;
    let allSelection = new AllSelection(tr.doc);
    tr.setSelection(allSelection);
    this.dispatch(tr);
  }
  unselect() {
    let tr = this.editorView.state.tr;
    tr.setSelection(Selection.atStart(tr.doc));
    this.dispatch(tr);
  }
  insertMarker(options = {}) {
    let state = this.editorView.state;
    let markerId = String(`marker-${this.markerCounter++}`);
    let elementAttributes = {
      id: markerId
    };
    if (options.class) {
      elementAttributes.class = options.class;
    }
    let marker = state.schema.nodes.marker.createAndFill(elementAttributes);
    let tr;
    if (state.selection.empty) {
      tr = state.tr.insert(state.selection.to, marker);
    } else {
      tr = state.tr.replaceWith(state.selection.from, state.selection.to, marker);
      tr = tr.setSelection(TextSelection.create(tr.doc, state.selection.from + 1));
    }
    this.dispatch(tr);
    return markerId;
  }
  insertAtMarker(id, content) {
    let state = this.editorView.state;
    let markerPos = this.findMarkerPosition(id);
    if (markerPos) {
      let slice = this.createSliceForContent(content);
      let tr = state.tr.replaceRange(markerPos, markerPos + 1, slice);
      tr = tr.scrollIntoView();
      this.dispatch(tr);
    }
    this.insertAttachments(content);
  }
  deleteMarker(id) {
    let state = this.editorView.state;
    let markerPos = this.findMarkerPosition(id);
    if (markerPos) {
      let tr = state.tr.delete(markerPos, markerPos + 1);
      this.dispatch(tr);
    }
  }
  deleteSelection() {
    let tr = this.editorView.state.tr;
    tr.deleteSelection();
    this.dispatch(tr);
  }
  toggleListType(type) {
    let listNodeType = this.schema.nodes[type];
    let listItemNodeType = this.schema.nodes.nestedListItem;
    chainCommands(autoJoin(changeNestedList(listNodeType), [type]), liftListItem(listItemNodeType), wrapInList(listNodeType))(this.editorView.state, this.dispatch);
  }
  updateSelectedNode(changedAttrs) {
    let selection = this.editorView.state.selection;
    if (selection instanceof NodeSelection) {
      let node = selection.node;
      let attrs = Object.assign({}, node.attrs, changedAttrs);
      let newNode = node.type.createAndFill(attrs, node.content, node.marks);
      if (newNode) {
        return this.replaceSelectionWith(newNode);
      }
    }
  }
  updateNode(nodeSelection, changedAttrs) {
    let mergedAttrs = {
      ...nodeSelection.node.attrs,
      ...changedAttrs
    };
    let tr = this.editorView.state.tr.setNodeMarkup(nodeSelection.from, undefined, mergedAttrs);
    let currentSelection = this.editorView.state.selection;
    this.dispatch(tr);
    if (currentSelection instanceof TextSelection) {
      tr = this.editorView.state.tr.setSelection(TextSelection.create(this.editorView.state.doc, currentSelection.anchor));
      this.dispatch(tr);
    }
  }
  updateSelectedButton(newAttrs) {
    if (this.isSelectedNodeType(BLOCK_TYPES.BUTTON)) {
      selectNodeForward(this.editorView.state, this.dispatch);
    }
    if (newAttrs?.linkUrl) {
      newAttrs.linkUrl = cleanUrl(newAttrs.linkUrl);
    }
    if (this.currentNodeSelection?.node) {
      let node = this.currentNodeSelection.node;
      this.updateNodeAttributes(node, newAttrs);
    }
  }
  updateNodeWidth(newWidth) {
    let selectedNode = findSelectionAnchorNode(this.editorView.state);
    this.updateNodeAttributes(selectedNode, {
      width: newWidth
    });
  }
  updateBorderWidth(newBorderWidth) {
    let selectedNode = findSelectionAnchorNode(this.editorView.state);
    this.updateNodeAttributes(selectedNode, {
      borderWidth: newBorderWidth
    });
  }
  updateBorderStyle(newBorderStyle) {
    let selectedNode = findSelectionAnchorNode(this.editorView.state);
    this.updateNodeAttributes(selectedNode, {
      borderStyle: newBorderStyle
    });
  }
  updateBorderColor(newBorderColor) {
    let selectedNode = findSelectionAnchorNode(this.editorView.state);
    this.updateNodeAttributes(selectedNode, {
      borderColor: newBorderColor
    });
  }
  toggleTableStacking() {
    selectNodeForward(this.editorView.state, this.dispatch);
    let node = this.currentNodeSelection.node;
    if (!node || !node.attrs.responsive) {
      return;
    }
    let newStackedStatus = node.attrs.stacked === true || node.attrs.stacked === false ? !node.attrs.stacked : false;
    this.updateNodeAttributes(node, {
      stacked: newStackedStatus
    });
  }
  setSelection(anchor, head) {
    let anchorPos = this.editorView.state.doc.resolve(anchor);
    let headPos = this.editorView.state.doc.resolve(head);
    this.dispatch(this.editorView.state.tr.setSelection(new TextSelection(anchorPos, headPos)));
  }
  undo() {
    return chainCommands(undoInputRule, undo)(this.editorView.state, this.dispatch);
  }
  redo() {
    return redo(this.editorView.state, this.dispatch);
  }
  async doUpload(file) {
    if (!this.uploadManager) {
      throw new Error('Tried to upload with no upload configuration');
    }
    return this.uploadManager.uploadFile(file);
  }
  async doUploadFromUrl(url) {
    if (!this.uploadManager) {
      throw new Error('Tried to upload with no upload configuration');
    }
    return this.uploadManager.uploadFileFromUrl(url);
  }
  async retryUpload(guid) {
    if (!this.uploadManager) {
      throw new Error('Tried to upload with no upload configuration');
    }
    let uploadResult = await this.uploadManager.retryUpload(guid);
    if (uploadResult) {
      updateNodeWithUploadResult(this.editorView, uploadResult, guid);
    }
  }
  async insertImageFile(file) {
    await this.insertImageFileAtRange(this.currentRange, file);
  }
  async uploadImage(imageNode, file) {
    let tempURL = window.URL.createObjectURL(file);
    let guid = guidFor(file);
    this.updateNode(imageNode, {
      fileGUID: guid,
      src: tempURL
    });
    let processingResult = await processImageFile(file);
    updateImageNodeWithProcessingResult(this.editorView, processingResult);
    let uploadResult = await this.doUpload(processingResult.file);
    updateNodeWithUploadResult(this.editorView, uploadResult);
  }
  async insertImageFileAtRange(range, file) {
    let tempURL = window.URL.createObjectURL(file);
    let guid = guidFor(file);
    this.insertNodeAtRange(range, this.createNode({
      src: tempURL,
      fileGUID: guid
    }, this.editorView.state.schema.nodes.image));
    let processingResult = await processImageFile(file);
    updateImageNodeWithProcessingResult(this.editorView, processingResult);
    let uploadResult = await this.doUpload(processingResult.file);
    updateNodeWithUploadResult(this.editorView, uploadResult);
  }
  async insertVideoFile(file) {
    await this.insertVideoFileAtRange(this.currentRange, file);
  }
  async insertAudioFile(file) {
    await this.insertAudioFileAtRange(this.currentRange, file);
  }
  async insertVideoFileAtRange(range, file) {
    let tempURL = window.URL.createObjectURL(file);
    let guid = guidFor(file);
    this.insertNodeAtRange(range, this.createNode({
      url: tempURL,
      fileGUID: guid
    }, this.editorView.state.schema.nodes.videoFile));
    let [videoMetadata, videoUploadResult] = await Promise.all([determineVideoMetadata(file), this.doUpload(file)]);
    let thumbnailFile = new File([dataURItoBlob(videoMetadata.thumbnailDataUrl)], 'thumbnail.jpg');
    let thumbnailUploadResult = await this.doUpload(thumbnailFile);
    updateVideoFileNodeWithDurationAndUploadResults({
      editorView: this.editorView,
      duration: videoMetadata.duration,
      thumbnailUploadResult,
      videoUploadResult
    });
  }
  async insertAudioFileAtRange(range, file) {
    let tempURL = window.URL.createObjectURL(file);
    let guid = guidFor(file);
    this.insertNodeAtRange(range, this.createNode({
      url: tempURL,
      fileGUID: guid
    }, this.editorView.state.schema.nodes.audioFile));
    let AudioUploadResult = await this.doUpload(file);
    updateAudioFileNodeWithUploadResults({
      editorView: this.editorView,
      AudioUploadResult
    });
  }
  async insertNewlineAndSelect() {
    return await createParagraphNear(this.editorView.state, this.dispatch);
  }
  async addAttachment(file) {
    if (this.attachmentList) {
      let attachment = this.attachmentList.addFile(file);
      let uploadResult = await this.doUpload(file);
      attachment.updateWithUploadResult(uploadResult);
      this.attachmentList.wasUpdated();
    }
  }
  insertAttachments(blocks) {
    if (this.attachmentList) {
      let attachments = AttachmentList.attachmentsFromBlocksDoc(new BlocksDocument(blocks));
      attachments.forEach(attachment => this.attachmentList?.addAttachment(attachment));
    }
  }
  insertCreateTicketCard(block) {
    this.insertTicketCardBlock?.addTicketBlock(block);
  }
  dispatch(t) {
    this.editorView.dispatch(t);
  }
  replaceSelectionWith(node) {
    let tr = this.editorView.state.tr;
    tr.replaceSelectionWith(node);
    tr.setSelection(NodeSelection.create(tr.doc, this.editorView.state.selection.from));
    this.dispatch(tr);
  }
  get schema() {
    return this.editorView.state.schema;
  }
  createNode(attrs, nodeSpec) {
    return nodeSpec.createAndFill(attrs);
  }
  createSlice(content, openStart = 0, openEnd = 0) {
    let prosemirrorDoc = new BlocksParser(this.schema).parse(new BlocksDocument(content), this.config);
    return new Slice(prosemirrorDoc.content, openStart, openEnd);
  }
  createSliceForContent(content) {
    let openStart = 0;
    let openEnd = 0;
    if (content[0].type === 'paragraph') {
      openStart = 1;
    }
    if (content[content.length - 1].type === 'paragraph') {
      openEnd = 1;
    }
    return this.createSlice(content, openStart, openEnd);
  }
  insertSocialItems(newSocialItems) {
    let selectedSocialNode = findSelectionAnchorNode(this.editorView.state);
    let socialItems = [...selectedSocialNode.attrs.items, ...newSocialItems];
    this.updateNodeAttributes(selectedSocialNode, {
      items: socialItems
    });
  }
  deleteSocialItem(itemIdToDelete) {
    let selectedSocialNode = findSelectionAnchorNode(this.editorView.state);
    if (!selectedSocialNode) {
      return;
    }
    let socialItems = [...selectedSocialNode.attrs.items];
    socialItems.splice(itemIdToDelete, 1);
    this.updateNodeAttributes(selectedSocialNode, {
      items: socialItems
    });
    if (socialItems.length === 0) {
      this.deleteSelection();
    }
  }
  updateSocialItemUrl(socialItemId, url) {
    let selectedSocialNode = findSelectionAnchorNode(this.editorView.state);
    if (!selectedSocialNode) {
      return;
    }
    let socialItems = [...selectedSocialNode.attrs.items];
    socialItems[socialItemId].url = url;
    this.updateNodeAttributes(selectedSocialNode, {
      items: socialItems
    });
  }
  updateNodeAttributes(node, updatedAttributes) {
    let position = this.editorView.state.selection.from;
    this.updateNodeAttributesAtPosition(node, position, updatedAttributes);
  }
  updateNodeAttributesAtPosition(node, position, updatedAttributes) {
    let tr = this.editorView.state.tr;
    let newAttrs = Object.assign({}, node.attrs, updatedAttributes);
    tr.setNodeMarkup(position, undefined, newAttrs);
    tr.setSelection(NodeSelection.create(tr.doc, position));
    this.dispatch(tr);
  }
  insertNodeAtRange(range, node) {
    if (range.from >= 0) {
      let tr = this.editorView.state.tr;
      tr.delete(range.from, range.to);
      let posAfterDelete = tr.mapping.map(range.from, -1);
      let insertPointPos = insertPoint(tr.doc, posAfterDelete, node.type);
      let newSelection;
      if (insertPointPos !== null && insertPointPos !== undefined && insertPointPos >= 0) {
        tr.insert(insertPointPos, node);
        newSelection = Selection.findFrom(tr.doc.resolve(insertPointPos), 1);
      } else {
        tr.insert(posAfterDelete, node);
        newSelection = Selection.findFrom(tr.doc.resolve(posAfterDelete + 1), 1);
      }
      if (newSelection) {
        tr.setSelection(newSelection);
      }
      tr = tr.scrollIntoView();
      this.dispatch(tr);
    } else {
      throw new Error(`Invalid Range ${range.from}->${range.to}`);
    }
  }
  convertNodeTo(nodeType, newAttrs = {}) {
    let node = this.currentNodeSelection.node;
    if (node) {
      let tr = this.editorView.state.tr;
      let attrs = Object.assign({}, node.attrs, newAttrs);
      tr.setNodeMarkup(this.currentNodeSelection.from, nodeType, attrs);
      this.dispatch(tr);
    }
  }
  get currentRange() {
    return {
      from: this.editorView.state.selection.from,
      to: this.editorView.state.selection.to
    };
  }
  findMarkerPosition(id) {
    let state = this.editorView.state;
    let markerPos = false;
    state.doc.descendants((node, pos) => {
      if (node.type === state.schema.nodes.marker && node.attrs.id === id) {
        markerPos = pos;
        return false;
      }
      return true;
    });
    return markerPos;
  }
  isSelectedNodeType(nodeTypeName) {
    return this.currentNodeSelection.$anchor.nodeAfter?.type.name === nodeTypeName;
  }
  get currentNodeSelection() {
    return this.editorView.state.selection;
  }
  diffFrom(otherBlocksDoc, stepsSinceLastChange = []) {
    let otherDoc = new BlocksParser(this.schema).parse(otherBlocksDoc, this.config);
    let newStateWithHighlights = changesetStateFrom(otherDoc, this.editorView.state, stepsSinceLastChange);
    this.editorView.updateState(newStateWithHighlights);
  }
  markAsInsertion() {
    let markType = this.schema.marks.insertion;
    let tr = this.editorView.state.tr;
    tr.addMark(this.editorView.state.selection.from, this.editorView.state.selection.to, markType.create());
    this.dispatch(tr);
  }
  removeInsertionMark() {
    let markType = this.schema.marks.insertion;
    if (selectionHasMark(this.editorView.state, markType)) {
      let tr = this.editorView.state.tr;
      tr.removeMark(this.editorView.state.selection.from, this.editorView.state.selection.to, markType);
      this.dispatch(tr);
    }
  }
  markAsDeletion() {
    let markType = this.schema.marks.deletion;
    let tr = this.editorView.state.tr;
    tr.addMark(this.editorView.state.selection.from, this.editorView.state.selection.to, markType.create());
    this.dispatch(tr);
  }
  removeDeletionMark() {
    let markType = this.schema.marks.deletion;
    if (selectionHasMark(this.editorView.state, markType)) {
      let tr = this.editorView.state.tr;
      tr.removeMark(this.editorView.state.selection.from, this.editorView.state.selection.to, markType);
      this.dispatch(tr);
    }
  }
}, _applyDecoratedDescriptor(_class.prototype, "focus", [action], Object.getOwnPropertyDescriptor(_class.prototype, "focus"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "dispatch", [action], Object.getOwnPropertyDescriptor(_class.prototype, "dispatch"), _class.prototype), _class);
export { Commands as default };